import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/esm/wrapNativeSuper";
export var SessionExistsError = /*#__PURE__*/function (_Error) {
  _inherits(SessionExistsError, _Error);

  var _super = _createSuper(SessionExistsError);

  function SessionExistsError() {
    _classCallCheck(this, SessionExistsError);

    return _super.call(this, 'CAS session exists');
  }

  return SessionExistsError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWJzL3Nlc3Npb24tZXhpc3RzLWVycm9yLnRzIl0sIm5hbWVzIjpbIlNlc3Npb25FeGlzdHNFcnJvciIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7O0FBQUEsV0FBYUEsa0JBQWI7QUFBQTs7QUFBQTs7QUFDRSxnQ0FBYztBQUFBOztBQUFBLDZCQUNOLG9CQURNO0FBRWI7O0FBSEg7QUFBQSxpQ0FBd0NDLEtBQXhDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIFNlc3Npb25FeGlzdHNFcnJvciBleHRlbmRzIEVycm9yIHtcbiAgY29uc3RydWN0b3IoKSB7XG4gICAgc3VwZXIoJ0NBUyBzZXNzaW9uIGV4aXN0cycpO1xuICB9XG59XG4iXX0=